var FlagAction = /** @class */ (function () {
    function FlagAction() {
    }
    return FlagAction;
}());
export { FlagAction };
/**
 * This interface describes the options controlling the creation of flags.
 */
var FlagCreationOptions = /** @class */ (function () {
    function FlagCreationOptions() {
    }
    return FlagCreationOptions;
}());
export { FlagCreationOptions };
//# sourceMappingURL=FlagCreationOptions.js.map